import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { Documento } from '../../../../model/class/Documento';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoriaDocumentosService } from '../../../services/categoria-documentos/categoria-documentos.service';
import * as _ from 'lodash';
import { CrearCategoriasDocumentosComponent } from '../crear-categorias-documentos/crear-categorias-documentos.component';
import { CategoriaDocumento } from '../../../../model/class/CategoriaDocumento';
import { DocumentoService } from '../../../services/documento/documento.service';
import { CrearFichaComponent } from '../crear-ficha/crear-ficha.component';
import { ConfirmService } from '../../../services/confirm/confirm.service';
import { ToastsManager } from 'ng2-toastr';

@Component({
  selector: 'app-listado-fichas',
  templateUrl: './listado-fichas.component.html',
  styleUrls: ['./listado-fichas.component.css']
})
export class ListadoFichasComponent implements OnInit {

  loader = {
    tabla: false
  };
  public options = {
    estado: 'todas',
    categoria: 0
  };
  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();

  page = 1;
  perPage = 20;
  totalData = 0;
  fichasTodas: Documento[] = [];
  categorias: CategoriaDocumento[] = [];
  orderSelected: any;
  headerTable: any[] = [
    {
      text: 'Nombre',
      value: 'nombre'
    }, {
      text: 'Archivo'
    }, {
      text: 'Categoría',
      value: 'publicada'
    }, {
      text: 'Estado',
      value: 'publicada'
    }
  ];

  constructor(
    private categoriaDocumentosService: CategoriaDocumentosService,
    private documentoService: DocumentoService,
    private modalService: NgbModal,
    private toasts: ToastsManager,
    private confirmService: ConfirmService,
  ) {
    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();
        this.loadFichas();
      });
  }

  ngOnInit() {
    this.loadFichas();
    const filtro: any[] = [{ 'published': true }];
    const parametros: any = { filter: JSON.stringify(filtro) };

    this.categoriaDocumentosService.gatAll(parametros)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          for (const iCat of response.data) {
            this.categorias.push(new CategoriaDocumento(iCat));
          }
        }, (error) => {
          this.loader.tabla = false;
        }
      );
  }

  onTextoBuscarChange(texto: string) {
    this.textoBuscarChanged.next(texto);
  }

  public loadFichas() {
    this.loader.tabla = true;
    this.fichasTodas = [];
    const parametros: any = {};
    const filtro: any[] = [];
    let texto: string;


    if (this.options.estado === 'publicadas') {
      filtro.push({ 'published': true });
    } else if (this.options.estado === 'noPublicadas') {
      filtro.push({ 'published': false });
    }

    if (this.options.categoria > 0) {
      filtro.push({ 'category_documents_id': this.options.categoria });
    }

    parametros.filter = JSON.stringify(filtro);

    if (this.textoBuscar) {
      texto = this.textoBuscar.trim();
    }
    if (texto) {
      const objetoBucar: any = [{ 'name': texto }];
      parametros.search = JSON.stringify(objetoBucar);
    }
    const paginador = {
      since: (this.page - 1) * this.perPage,
      quantity: this.perPage
    };
    parametros.paginator = JSON.stringify(paginador);

    this.documentoService.gatAll(parametros)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          this.totalData = response.total;
          for (const iDoc of response.data) {
            this.fichasTodas.push(new Documento(iDoc));
          }
          this.orderData();
        }, (error) => {
          this.loader.tabla = false;
        }
      );
  }

  limpiarTexto() {
    this.textoBuscar = '';
    this.loadFichas();
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === 'desc') {
            this.headerTable[i].order = 'asc';
          } else if (this.headerTable[i].order === 'asc') {
            this.headerTable[i].order = 'desc';
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = 'asc';
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.fichasTodas = _.orderBy(this.fichasTodas, this.orderSelected.value, this.orderSelected.order);
    }
  }

  pageChange(event) {
    this.page = event;
    this.loadFichas();
  }

  creatCategoria() {
    const viewModal = this.modalService.open(CrearCategoriasDocumentosComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.newCategoria = {};

    viewModal.result
      .then((newCategoria: CategoriaDocumento) => {
        const newObj = new CategoriaDocumento(newCategoria);
        if (newObj.publicada) {
          this.categorias.push(newObj);
        }
      }, (reason) => {
      });
  }

  eliminarFicha(ficha: Documento) {
    this.confirmService.confirm('Eliminar',
      '¿Seguro que desea eliminar este Producto?')
      .then((resp) => {
        if (resp) {
          this.loader.tabla = true;

          this.documentoService.delete(ficha.id)
            .subscribe(
              (data) => {
                this.toasts.success('Ficha eliminada.');
                this.loadFichas();
              }, (error) => {
                this.toasts.error('Problemas al eliminar la ficha.');
              }
            );
        }
      });
  }

  crearEditarFicha(ficha?: Documento) {

    let clon: any = {};

    if (ficha) {
      clon = _.clone(ficha);
    }

    const viewModal = this.modalService.open(CrearFichaComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.newDocumento = clon;
    viewModal.componentInstance.categorias = this.categorias;

    viewModal.result
      .then((newDocument: Documento) => {
        const newObj = new Documento(newDocument);
        if (clon.id) {
          // Editando
          const indice = _.findIndex(this.fichasTodas, { id: newObj.id });
          console.log('indice', indice);
          console.log('this.options.categoria', this.options.categoria);
          if (indice >= 0) {
            if (
              (this.options.categoria === 0 || newObj.categoriaDocumentoId === this.options.categoria)
              && (this.options.estado === 'todas' ||
                (this.options.estado === 'publicadas' && newObj.publicada) ||
                (this.options.estado === 'noPublicadas' && !newObj.publicada))
            ) {
              this.fichasTodas[indice] = newObj;
            } else {
              this.fichasTodas.splice(indice, 1);
            }
          }
        } else {
          // Nuevo
          if (this.fichasTodas.length < this.perPage) {
            if (
              (this.options.categoria === 0 || newObj.categoriaDocumentoId === this.options.categoria)
              && (this.options.estado === 'todas' ||
                (this.options.estado === 'publicadas' && newObj.publicada) ||
                (this.options.estado === 'noPublicadas' && !newObj.publicada))
            ) {
              this.fichasTodas.push(newObj);
            }
          }
        }
      }, (reason) => {
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/listado-fichas/listado-fichas.component.ts